import axios from 'axios';

const axios_instance = axios.create({
  withCredentials: true,
});

// Cookie auth is preferred, but incognito/Safari block third-party cookies.
// Fall back to the JWT stored at login so verifyToken can still read Bearer.
axios_instance.interceptors.request.use((config) => {
  const accessToken = sessionStorage.getItem('authToken');
  if (accessToken) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  }
  return config;
});

export default axios_instance;
